import { Rise, Words } from "../components/Reveal";
import { COPY } from "../content/copy";

export default function Metodo() {
    const m = COPY.metodo;
    return (
        <section id="metodo" className="section metodo" data-testid="metodo-block">
            <div className="container">
                <Rise>
                    <p className="caption">{m.caption}</p>
                </Rise>
                <Rise delay={0.05}>
                    <h2 className="h2 section-title" data-testid="metodo-title">
                        <Words text={m.titleA} />{" "}
                        <Words text={m.titleB} italic />
                    </h2>
                </Rise>
                <Rise delay={0.1}>
                    <p className="lead section-lead">{m.lead}</p>
                </Rise>
            </div>
        </section>
    );
}
